import COPY from "~config/copy-constants"
import type {
    LodgingFieldsFragment,
    ResourceFieldsFragment,
} from "~graphql/generated/graphql"

export function formatCapacity(
    lodge:
        | Pick<LodgingFieldsFragment, "capacity">
        | Pick<ResourceFieldsFragment, "capacity">
) {
    return `${lodge.capacity} ${COPY.CAPACITY}`
}
